import { api } from './api';

export interface FeedToken {
  id: string;
  token: string;
  companyId: string;
  appType: string;
  enabled: boolean;
  createdAt: string;
  createdBy: string;
  feedUrl: string;
}

export interface CreateFeedTokenResponse {
  token: string;
  feedUrl: string;
}

export class FeedTokenService {
  /**
   * Get all feed tokens for a company
   */
  static async getTokens(companyId?: string): Promise<FeedToken[]> {
    const params = companyId ? { companyId } : {};
    const response = await api.get<FeedToken[]>('/article-creator/feed-tokens', params);
    if (!response.success) {
      const errorMsg = typeof response.error === 'string' ? response.error : response.error?.message || 'Failed to fetch feed tokens';
      throw new Error(errorMsg);
    }
    return response.data || [];
  }

  /**
   * Create a new feed token
   */
  static async createToken(companyId?: string): Promise<CreateFeedTokenResponse> {
    const params = companyId ? { companyId } : {};
    const response = await api.post<CreateFeedTokenResponse>('/article-creator/feed-token', params);
    if (!response.success) {
      const errorMsg = typeof response.error === 'string' ? response.error : response.error?.message || 'Failed to create feed token';
      throw new Error(errorMsg);
    }
    return response.data!;
  }

  /**
   * Delete a feed token
   */
  static async deleteToken(token: string, _companyId?: string): Promise<void> {
    // Note: companyId is validated on backend via auth token
    const response = await api.delete(`/article-creator/feed-token/${token}`);
    if (!response.success) {
      const errorMsg = typeof response.error === 'string' ? response.error : response.error?.message || 'Failed to delete feed token';
      throw new Error(errorMsg);
    }
  }

  /**
   * Regenerate feed token (delete old, create new)
   */
  static async regenerateToken(oldToken: string, companyId?: string): Promise<CreateFeedTokenResponse> {
    // Delete old token first
    await this.deleteToken(oldToken, companyId);
    // Create new token
    return this.createToken(companyId);
  }
}
